export const accountColorPalette = [
  // Reds
  { "name": "Light Red", "value": "#FF7F7F" },
  { "name": "Red", "value": "#FF0000" },
  { "name": "Dark Red", "value": "#B22222" },
  { "name": "Crimson", "value": "#DC143C" },
  { "name": "Maroon", "value": "#800000" },

  // Oranges
  { "name": "Light Orange", "value": "#FFD580" },
  { "name": "Orange", "value": "#FFA500" },
  { "name": "Dark Orange", "value": "#FF8C00" },
  { "name": "Burnt Orange", "value": "#CC5500" },
  { "name": "Rust", "value": "#8B4000" },

  // Yellows
  { "name": "Mustard", "value": "#c5c52c" },
  { "name": "Gold", "value": "#FFD700" },
  { "name": "Goldenrod", "value": "#DAA520" },
  { "name": "Dark Khaki", "value": "#BDB76B" },

  // Greens
  { "name": "Light Green", "value": "#90EE90" },
  { "name": "Lime", "value": "#2dda2d" },
  { "name": "Green", "value": "#008000" },
  { "name": "Dark Green", "value": "#006400" },
  { "name": "Olive", "value": "#556B2F" },

  // Blues
  { "name": "Light Blue", "value": "#ADD8E6" },
  { "name": "Sky Blue", "value": "#87CEEB" },
  { 'name': "CFB Blue", "value": "#14B3E8" },
  { "name": "OneEthos Blue", "value": "#3182CE"},
  { "name": "Blue", "value": "#0000FF" },
  { "name": "Navy", "value": "#000080" },
  { "name": "Steel Blue", "value": "#4682B4" },

  // Violets / Purples
  { "name": "Violet", "value": "#EE82EE" },
  { "name": "Purple", "value": "#800080" },
  { "name": "Indigo", "value": "#4B0082" },
  { "name": "Dark Magenta", "value": "#8B008B" },

  // Neutral tones
  { "name": "Light Gray", "value": "#D3D3D3" },
  { "name": "Gray", "value": "#808080" },
  { "name": "Dark Gray", "value": "#404040" },
  { "name": "Black", "value": "#000000" }
]
